export default "__VITE_ASSET__CLghcp35__"